"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.descendingComparator = descendingComparator;
exports.getComparator = getComparator;
exports.stableSort = stableSort;
function descendingComparator(a, b, orderBy, order) {
  var _b$orderBy, _a$orderBy;
  // first attempt to parse into a numeric value and compare
  const numCompare = descendingNumComparator(a, b, orderBy);
  if (numCompare !== null) {
    if (numCompare === 0) {
      return numCompare;
    } else {
      return order === 'desc' ? numCompare * -1 : numCompare;
    }
  }

  // if non-numeric, compare using the javascript built-in compare for this type
  const bValue = (_b$orderBy = b[orderBy]) !== null && _b$orderBy !== void 0 ? _b$orderBy : '';
  const aValue = (_a$orderBy = a[orderBy]) !== null && _a$orderBy !== void 0 ? _a$orderBy : '';

  // blank values at the end always (any order)
  if (isEmptyValue(aValue.toString()) && isEmptyValue(bValue.toString())) {
    return 0;
  }
  if (isEmptyValue(aValue.toString())) {
    return 1;
  }
  if (isEmptyValue(bValue.toString())) {
    return -1;
  }
  if (bValue < aValue) {
    return order === 'desc' ? -1 : 1;
  }
  if (bValue > aValue) {
    return order === 'desc' ? 1 : -1;
  }
  return 0;
}
function isEmptyValue(value) {
  if (value === '' || value === null || (value === null || value === void 0 ? void 0 : value.toString().trim()) === '' || value === undefined) {
    return true;
  } else {
    return false;
  }
}
function descendingNumComparator(a, b, orderBy) {
  var _a$orderBy2, _b$orderBy2;
  const aNumValue = Number((_a$orderBy2 = a[orderBy]) !== null && _a$orderBy2 !== void 0 ? _a$orderBy2 : '0.0');
  const bNumValue = Number((_b$orderBy2 = b[orderBy]) !== null && _b$orderBy2 !== void 0 ? _b$orderBy2 : '0.0');
  if (!isNaN(aNumValue) && !isNaN(bNumValue)) {
    return bNumValue - aNumValue;
  }
  return null;
}
function getComparator(order, orderBy, sorting) {
  return (a, b) => sorting(a, b, orderBy, order);
}
function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}